import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { sentry } from 'sentry';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { UploadService } from '@core/services/upload.service';
import { fileToBase64 } from '@core/utils/file-converter';
import { TranslateService } from '@ngx-translate/core';
import { EquipmentsService } from 'app/main/equipments/services/equipments-resolver.service';
var TabAttachmentsComponent = /** @class */ (function () {
    function TabAttachmentsComponent(fb, imageUploadService, translateService, equipmentsService, customMessageService) {
        this.fb = fb;
        this.imageUploadService = imageUploadService;
        this.translateService = translateService;
        this.equipmentsService = equipmentsService;
        this.customMessageService = customMessageService;
        this.images = {
            isUploading: false,
            hasErrors: {
                type: false,
                size: false,
                max: false
            }
        };
        this.isSaving = false;
        this.updatingAttachmentId = 0;
    }
    TabAttachmentsComponent.prototype.ngOnInit = function () {
        var attachments = this.equipment.attachments.filter(function (attachment) { return !attachment.archived; });
        this.setAttachments(attachments);
    };
    TabAttachmentsComponent.prototype.setAttachments = function (attachments) {
        var _this = this;
        this.attachmentsFormArray = this.fb.array(attachments.map(function (attachment) {
            return _this.fb.group({
                id: _this.fb.control(attachment.id),
                title: _this.fb.control(attachment.title),
                newTitle: _this.fb.control(attachment.title),
                path: _this.fb.control(attachment.path),
                size: _this.fb.control(attachment.size),
                createdAt: _this.fb.control(attachment.createdAt),
                isChangingTitle: _this.fb.control(false),
                isDeleting: _this.fb.control(false)
            });
        }));
    };
    TabAttachmentsComponent.prototype.enableChangeAttachmentTitle = function (attachment, attachmentIndex) {
        attachment.get('isChangingTitle').setValue(true);
        setTimeout(function () {
            document.getElementById("attachment-" + attachmentIndex + "-title").focus();
        }, 0);
    };
    TabAttachmentsComponent.prototype.cancelChangeAttachmentTitle = function (attachment) {
        attachment.get('isChangingTitle').setValue(false);
        if (attachment.value.title !== attachment.value.newTitle) {
            attachment.get('newTitle').setValue(null);
        }
    };
    TabAttachmentsComponent.prototype.imageValidation = function (imagesInput) {
        var acceptedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        this.images.hasErrors.type = false;
        this.images.hasErrors.type = false;
        this.images.hasErrors.size = false;
        this.images.hasErrors.max = false;
        if (!imagesInput.length) {
            return false;
        }
        if (imagesInput.length > 20) {
            this.images.hasErrors.max = true;
            return false;
        }
        var hasAllImagesWithAcceptableType = imagesInput.every(function (imageInput) {
            return acceptedTypes.includes(imageInput.type);
        });
        var hasAllImagesWithAcceptableSize = imagesInput.every(function (imageInput) {
            return imageInput.size <= 2097152;
        });
        if (!hasAllImagesWithAcceptableType) {
            this.images.hasErrors.type = true;
            return false;
        }
        if (!hasAllImagesWithAcceptableSize) {
            this.images.hasErrors.size = true;
            return false;
        }
        return true;
    };
    TabAttachmentsComponent.prototype.addNewAttachments = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var imagesInput, imagesArray, imagesValidation, imageIndex, imageInformation, _a, imageUploaded, attachmentAdded, newAttachmentIndex, newAttachmentControl, successMessage, err_1, errorMessage;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        imagesInput = event.target.files;
                        imagesArray = Array.from(imagesInput);
                        imagesValidation = this.imageValidation(imagesArray);
                        if (!imagesValidation) {
                            return [2 /*return*/];
                        }
                        this.images.isUploading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 8, 9, 10]);
                        imageIndex = 0;
                        _b.label = 2;
                    case 2:
                        if (!(imageIndex < imagesArray.length)) return [3 /*break*/, 7];
                        _a = {};
                        return [4 /*yield*/, fileToBase64(imagesInput[imageIndex])];
                    case 3:
                        imageInformation = (_a.imageBase64Encoded = _b.sent(),
                            _a.filename = imagesArray[imageIndex].name,
                            _a.size = imagesArray[imageIndex].size,
                            _a.path = "equipments/" + this.equipment.id + "/attachments",
                            _a);
                        return [4 /*yield*/, this.imageUploadService.upload(imageInformation)];
                    case 4:
                        imageUploaded = _b.sent();
                        return [4 /*yield*/, this.equipmentsService.saveEquipmentAttachment(null, {
                                path: imageUploaded.path,
                                size: imageUploaded.size,
                                equipmentId: this.equipment.id
                            })];
                    case 5:
                        attachmentAdded = _b.sent();
                        newAttachmentIndex = this.attachmentsFormArray.controls.length;
                        newAttachmentControl = this.fb.group({
                            id: this.fb.control(attachmentAdded.id),
                            title: this.fb.control(attachmentAdded.title),
                            newTitle: this.fb.control(attachmentAdded.title),
                            path: this.fb.control(attachmentAdded.path),
                            size: this.fb.control(attachmentAdded.size),
                            createdAt: this.fb.control(attachmentAdded.createdAt),
                            isChangingTitle: this.fb.control(false),
                            isDeleting: this.fb.control(false)
                        });
                        this.attachmentsFormArray.setControl(newAttachmentIndex, newAttachmentControl);
                        _b.label = 6;
                    case 6:
                        imageIndex++;
                        return [3 /*break*/, 2];
                    case 7:
                        successMessage = imagesArray.length > 1 ? 'ALL_SUCCESS' : 'SUCCESS';
                        this.customMessageService.success("EQUIPMENTS.DIALOG.ATTACHMENTS.MESSAGES." + successMessage);
                        return [3 /*break*/, 10];
                    case 8:
                        err_1 = _b.sent();
                        errorMessage = imagesArray.length > 1 ? 'ALL_ERROR' : 'ERROR';
                        this.customMessageService.error("EQUIPMENTS.DIALOG.ATTACHMENTS.MESSAGES." + errorMessage);
                        sentry.captureException(err_1);
                        return [3 /*break*/, 10];
                    case 9:
                        this.images.isUploading = false;
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    TabAttachmentsComponent.prototype.updateAttachmentTitle = function (attachment) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var input, err_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attachment.get('isChangingTitle').setValue(false);
                        this.updatingAttachmentId = attachment.value.id;
                        this.isSaving = true;
                        input = {
                            title: attachment.value.newTitle,
                            path: attachment.value.path,
                            size: attachment.value.size,
                            equipmentId: this.equipment.id
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.equipmentsService.saveEquipmentAttachment(attachment.value.id, input)];
                    case 2:
                        _a.sent();
                        attachment.get('title').setValue(input.title);
                        this.customMessageService.success('EQUIPMENTS.DIALOG.ATTACHMENTS.MESSAGES.SUCCESS');
                        return [3 /*break*/, 5];
                    case 3:
                        err_2 = _a.sent();
                        this.customMessageService.error('EQUIPMENTS.DIALOG.ATTACHMENTS.MESSAGES.ERROR');
                        sentry.captureException(err_2);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isSaving = false;
                        this.updatingAttachmentId = 0;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    TabAttachmentsComponent.prototype.deleteAttachment = function (attachment, attachmentIndex) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isSaving = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.equipmentsService.saveEquipmentAttachment(attachment.value.id, null)];
                    case 2:
                        _a.sent();
                        this.attachmentsFormArray.removeAt(attachmentIndex);
                        this.customMessageService.success('EQUIPMENTS.DIALOG.ATTACHMENTS.MESSAGES.SUCCESS_DELETE');
                        return [3 /*break*/, 5];
                    case 3:
                        err_3 = _a.sent();
                        this.customMessageService.error('EQUIPMENTS.DIALOG.ATTACHMENTS.MESSAGES.ERROR_DELETE');
                        sentry.captureException(err_3);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isSaving = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return TabAttachmentsComponent;
}());
export { TabAttachmentsComponent };
